module.exports = __webpack_public_path__ + "img/ticket.777afb65.svg";